import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router-dom';
import FilterChips from 'feature/dispatching/components/FilterChips';
import TrailerControls from './TrailerControls';
import TrailerProperties from './TrailerProperties';

const boxStyles = {
  alignItems: 'center',
  backgroundColor: 'surface.light',
  display: 'grid',
  gridTemplateColumns: '1fr auto',
  overflow: 'hidden',
  p: 3,
  position: 'sticky',
  textOverflow: 'ellipsis',
  top: 48,
  zIndex: 2,
};

const TrailerHeader = ({
  cardsFilters,
  defaultFiltersState,
  onResetFilters,
  setCardsFilters,
  onCreateTrailer,
  setViewTrailerId,
  onRemoveFilter,
  isLoading,
  isSuccess,
  trailerData,
}) => {
  const { viewById } = useParams();

  const vtc = isLoading
    ? 'Loading...'
    : isSuccess && R.isEmpty(trailerData)
    ? 'No Results'
    : isSuccess
    ? `TRAILER ID ${R.toUpper(trailerData?.vaporTightnessCode)}`
    : '';
  return (
    <Box sx={boxStyles}>
      <Typography noWrap sx={{ alignSelf: 'end', color: 'text.primary' }} variant="h5">
        {vtc}
      </Typography>
      <Box sx={{ gridColumn: 2 }}>
        <TrailerControls
          cardsFilters={cardsFilters}
          defaultFiltersState={defaultFiltersState}
          isLoading={isLoading}
          isSuccess={isSuccess}
          onCreateTrailer={onCreateTrailer}
          onViewTrailer={setViewTrailerId}
          resetFilters={onResetFilters}
          setCardsFilters={setCardsFilters}
          trailer={trailerData}
        />
      </Box>
      <Box sx={{ gridColumn: '1 / 3', gridRowStart: 3 }}>
        {!R.isNil(viewById) && <TrailerProperties isSuccess={isSuccess} trailer={trailerData} />}
      </Box>
      <Box sx={{ gridColumn: '1 / 3', gridRowStart: 4 }}>
        <FilterChips
          defaultState={defaultFiltersState}
          filters={cardsFilters}
          onRemove={onRemoveFilter}
        />
      </Box>
    </Box>
  );
};

TrailerHeader.propTypes = {
  cardsFilters: PropTypes.shape({}).isRequired,
  defaultFiltersState: PropTypes.shape({}).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  onCreateTrailer: PropTypes.func.isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
  setViewTrailerId: PropTypes.func.isRequired,
  trailerData: PropTypes.shape({
    vaporTightnessCode: PropTypes.string,
  }).isRequired,
};

export default TrailerHeader;
